// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__Tocmt","filesListContainer":"PosDisputesFiles_filesListContainer__2vnID","filesButton":"PosDisputesFiles_filesButton__InJB1"};